import { render, staticRenderFns } from "./CRUDStatusTickets.vue?vue&type=template&id=287d6439&"
import script from "./CRUDStatusTickets.vue?vue&type=script&lang=js&"
export * from "./CRUDStatusTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports